"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersModule = void 0;
const router_1 = require("client/components/router");
const users_list_1 = require("./modules/users-list");
const users_permissions_1 = require("./modules/users-permissions");
class UsersModule extends router_1.Router {
    constructor(props) {
        super(props);
        this.addRoute("list", /^\/users\/?$/, users_list_1.UsersList);
        this.addRoute("detail", /^\/users\/(\d+)/, users_list_1.UsersList);
        this.addRoute("permissions", /^\/users\/permissions/, users_permissions_1.UsersPermissions);
    }
}
exports.UsersModule = UsersModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/users/users.tsx
// module id = 4150
// module chunks = 0